import { SxProps, Theme } from '@mui/material/styles';

export const cellSx: SxProps<Theme> = {
  fontSize: '12px',
  py: 0.75,
  px: 1.5,
};

export const headerSx: SxProps<Theme> = {
  ...cellSx,
  fontWeight: 600,
  color: 'text.secondary',
  fontSize: '11px',
  textTransform: 'uppercase' as const,
  letterSpacing: '0.03em',
};

export const btnSx: SxProps<Theme> = {
  fontSize: '11px',
  textTransform: 'none' as const,
  py: 0.75,
  px: 2,
  bgcolor: 'v4.accent',
  color: 'common.white',
  '&:hover': { bgcolor: 'v4.accent', opacity: 0.9 },
};

export const fieldSx: SxProps<Theme> = {
  fontSize: '12px',
  border: '1px solid',
  borderColor: 'v4.borderDark',
  borderRadius: 1,
  px: 1,
  py: 0.5,
  width: '100%',
};

export const labelSx: SxProps<Theme> = {
  fontSize: '9px',
  fontWeight: 600,
  color: 'text.secondary',
  textTransform: 'uppercase' as const,
  letterSpacing: '0.04em',
  mb: 0.25,
};

export const formatDate = (d?: string): string => {
  if (!d) return '-';
  try {
    return new Date(d).toLocaleDateString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    });
  } catch {
    return '-';
  }
};

export interface ManifestEntry {
  key: string;
  type: 'serialised' | 'non-serialised';
  partTypeName: string;
  partTypeNo: string;
  serial?: string;
  quantity: number;
}
